// extracted by mini-css-extract-plugin
export default {"container":"CookiePolicyPage_container__idqQ1"};